module.exports = __webpack_public_path__ + "img/apoio-eneei.cd0c5a01.png";